export default __webpack_public_path__ + "static/media/mus-df.67881762.mp4";